export const QUEST_DISSOLVE_MS = 1450;
export const QUEST_DISSOLVE_MS_REDUCED = 250;

export function getQuestDissolveMs(): number {
  if (typeof window === 'undefined') {
    return QUEST_DISSOLVE_MS;
  }

  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? QUEST_DISSOLVE_MS_REDUCED
    : QUEST_DISSOLVE_MS;
}

export function prefersReducedQuestMotion(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
